import { render, staticRenderFns } from "./MasterLayout.vue?vue&type=template&id=244a33e8"
import script from "./MasterLayout.vue?vue&type=script&lang=js"
export * from "./MasterLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports